<template>
  <font-size-tracker>
    <div class="emblem" :class="{vault: character.isVault}">
      <div class="emblem-inner" v-bind:style="styleObject">
      </div>
      <div class="class-name">{{ character.className }}</div>
      <div class="gender"> {{ character.raceName }}</div>
      <div class="level">{{ character.level }}</div>
      <div class="light">{{ character.light }}</div>
    </div>
  </font-size-tracker>
</template>

<script>
  // import _ from 'underscore'
  import FontSizeTracker from '@/components/FontSizeTracker'

  export default {
    name: 'emblem',
    data () {
      return {}
    },
    props: ['character'],
    computed: {
      styleObject () {
        return {
          backgroundImage: 'url(' + this.character.emblemBackgroundPath + ')'
        }
      }
    },
    components: {
      FontSizeTracker
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .emblem {
    width: 100%;
    padding-bottom: 20%;
    position: relative;
  }

  .emblem-inner {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: 100%;
  }

  .class-name {
    position: absolute;
    left: 25%;
    font-size: 30%;
    top: 10%;
    font-weight: 400;
  }

  .gender {
    font-size: 30%;
    position: absolute;
    left: 25%;
    bottom: 10%;
  }

  .level {
    position: absolute;
    right: 5%;
    font-size: 55%;

  }

  .light {
    position: absolute;
    right: 5%;
    font-size: 30%;
    bottom: 10%;
    color: rgba(245, 220, 86, 1);
  }

  img {
    height: 70%;
    position: absolute;
    left: 4%;
    top: 15%;
  }
</style>



// WEBPACK FOOTER //
// Emblem.vue?16fb4394